export const withSubcontractors = (Component) => (props) => {
  const { data } = props || {};
  const { pr__subcontractors = [] } = data || {};

  return <Component {...props} rows={pr__subcontractors} />;
};
